if (!customElements.get('faq-accordions')) {
  class FaqAccordions extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.setupAccordions();
    }

    setupAccordions() {
      // Get all accordion headers within this component
      const accordionHeaders = this.querySelectorAll('.js-accordion-header');
      
      accordionHeaders.forEach(header => {
        header.addEventListener('click', (event) => {
          this.handleAccordionClick(event, header);
        });
      });
    }

    handleAccordionClick(event, clickedHeader) {
      const isExpanded = clickedHeader.getAttribute('aria-expanded') === 'true';
      const content = clickedHeader.nextElementSibling;
      
      // Close all other accordions
      const allHeaders = this.querySelectorAll('.js-accordion-header');
      allHeaders.forEach(header => {
        if (header !== clickedHeader) {
          header.setAttribute('aria-expanded', 'false');
          const otherContent = header.nextElementSibling;
          if (otherContent) {
            this.closeAccordion(otherContent);
          }
        }
      });
      
      // Toggle current accordion
      clickedHeader.setAttribute('aria-expanded', !isExpanded);
      if (!isExpanded) {
        this.openAccordion(content);
      } else {
        this.closeAccordion(content);
      }
    }

    openAccordion(content) {
      // Temporarily remove hidden to measure content
      content.removeAttribute('hidden');
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
      
      // Force reflow
      content.offsetHeight;
      
      // Set to actual height
      const scrollHeight = content.scrollHeight;
      content.style.maxHeight = scrollHeight + 'px';
      content.style.opacity = '1';
    }

    closeAccordion(content) {
      // Set current height
      content.style.maxHeight = content.scrollHeight + 'px';
      content.style.opacity = '1';
      
      // Force reflow
      content.offsetHeight;
      
      // Collapse
      content.style.maxHeight = '0px';
      content.style.opacity = '0';
    }
  }

  // Register the custom element
  customElements.define('faq-accordions', FaqAccordions);
}
